/*
 * Created by patricio on 11/10/16.
 */

/*
first_time_uk_deposit
*/

import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';

const conf = {
	showDepositLimitOptionUrl: '/UkComplianceService/ukShowDepositLimitOption',
	ukSetResponsibleGamingDepositLimitUrl: '/UkComplianceService/ukSetResponsibleGamingDepositLimit'
};

const state = {
	isFirstTime: null
};
const register = dataflow.register;

function viewUpdate() {
	view.update({
		first_time_uk_deposit: state
	});
}

function parseToState(data) {
	if (data) {
		if (data.JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION === 'YES') {
			state.isFirstTime = true;
			viewUpdate();
		} else if (data.JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION === 'NO') {
			state.isFirstTime = false;
			viewUpdate();
		} else {
			console.warn('first_time_uk_deposit:parseToState: can not get "JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION"', data);
		}
	} else {
		console.error('first_time_uk_deposit:50:parseToState:can not read data:', data);
	}
}

function getDataAndReplaceState() {
	function successHandler(data) {
		parseToState(data);
	}

	function errorHandler(err) {
		console.error('first_time_uk_deposit:error:', err);
	}

	core.get(conf.showDepositLimitOptionUrl, successHandler, errorHandler);
}

function sendDailyLimit(amount = null) {
	// send POST request to set new limit up
	function successHandler(data) {
		console.info('first_time_uk_deposit:sendDailyLimit:successHandler:limited updated', data);
	}

	function errorHandler(err) {
		console.error('first_time_uk_deposit:error:limit not updated', err);
	}

	const data = {
		depositLimitValue: amount,
		isMobileDevice: true,
		limitType: 'deposit-daily',
		firstDeposit: true
	};

	const url = conf.ukSetResponsibleGamingDepositLimitUrl;
	core.post(url, jQuery.param(data), successHandler, errorHandler, 'application/x-www-form-urlencoded');
}

function registerActions() {
	function firstTimeUkDepositActions(payload) {
		if (payload.type === constants.SETUP_PAYMENT) {
			/* initialize the request to check it the link shall be present in the view */
			getDataAndReplaceState();
		}
		if (payload.type === constants.VIEW_UK_FIRST_TIME_DEPOSIT_LINK) {
			/* it this action is dispatched from the view, for example a click on the link, the
			new request to set the limit will be done. */
			// We don't do anything with the response of this call (in desktop) but we could
			// use notifications.informationMessage feature
			const amount = (payload.data || null);
			if (amount) {
				sendDailyLimit(amount);
			} else {
				console.info('first-time-uk-deposit: no limit is set, amount was zero or nothing');
			}
		}
	}

	register(firstTimeUkDepositActions);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/first-time-uk-deposit.js